import React, { useCallback, useMemo, useState } from 'react'

import { CRM_ACTION_REGISTRY, type CrmActionKind } from './crmActionRegistry'
import { CrmActionHostContext, type CrmActionHostContextValue, type CrmActionHostOpenArgs } from './useCrmActionHost'

interface ActiveModal {
  kind: CrmActionKind
  args: CrmActionHostOpenArgs
}

export const CrmActionHostProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [active, setActive] = useState<ActiveModal | null>(null)

  const open = useCallback((kind: CrmActionKind, args: CrmActionHostOpenArgs) => {
    setActive({ kind, args })
  }, [])

  const close = useCallback(() => {
    setActive(null)
  }, [])

  const value = useMemo<CrmActionHostContextValue>(() => ({ open, close }), [open, close])

  const ActiveModalComponent = active ? CRM_ACTION_REGISTRY[active.kind].Modal : null

  return (
    <CrmActionHostContext.Provider value={value}>
      {children}
      {ActiveModalComponent && active ? <ActiveModalComponent open onClose={close} resolveResults={active.args.resolveResults} /> : null}
    </CrmActionHostContext.Provider>
  )
}
